export default __webpack_public_path__ + "static/media/panel5.0ba65b67.jpg";